import { useUserStore } from "@/entities/user";
import { ClientList } from "@/widgets/client-list";
import { CampaignList } from "@/widgets/campaign-list";

export const HomePage = () => {
  const user = useUserStore((s) => s.user);
  const isAgency = user?.account_type === "AGENCY";

  return (
    <div className="flex flex-col gap-6">
      {isAgency ? <ClientList /> : <CampaignList />}
    </div>
  );
};
